import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["label", "position", "setPosition", "isVisible", "triggerRect", "style", "type", "className", "isDark", "dark", "htmlProps"];
import { forwardRef, useRef } from 'react';
import cn from 'classnames';
import parseClassnames from "../helpers/parseClassnames";
import useRect from "../helpers/useRect";
import getPosition from "./helpers/getPosition";
import getStyles from "./helpers/getStyles";
import { jsx as _jsx } from "react/jsx-runtime";
var TooltipContent = function TooltipContent(_ref, forwardedRef) {
  var label = _ref.label,
    position = _ref.position,
    _ref$setPosition = _ref.setPosition,
    setPosition = _ref$setPosition === void 0 ? getPosition : _ref$setPosition,
    isVisible = _ref.isVisible,
    triggerRect = _ref.triggerRect,
    style = _ref.style,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'regular' : _ref$type,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    isDark = _ref.isDark,
    dark = _ref.dark,
    htmlProps = _ref.htmlProps,
    tooltipContentProps = _objectWithoutProperties(_ref, _excluded);
  var ownRef = useRef(null);
  var ref = forwardedRef || ownRef;
  var tooltipRect = useRect(ownRef, isVisible);
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread(_objectSpread({
    role: "tooltip",
    style: _objectSpread(_objectSpread({}, style), getStyles(setPosition, triggerRect, tooltipRect, position)),
    ref: ref,
    className: parseClassnames(className, cn("shadow-tooltip rounded-5 font-legals absolute z-dialog pointer-events-none whitespace-no-wrap", isDark || dark ? 'bg-base-lighter-dark-mode text-white' : 'bg-white text-base-main', {
      'p-8': type === 'regular',
      'p-4': type === 'small'
    }))
  }, tooltipContentProps), htmlProps), {}, {
    children: label
  }));
};
export default /*#__PURE__*/forwardRef(TooltipContent);